export const mapQuestions = (questions, answers = []) => {
    const result = questions.map((question) => {
        let options = [];

        const questionSettings = question.question_setting;

        if (question.type === 'radiobox') {
            options = (question?.options || []).map((option) => {
                const children = [];

                if(option.type !== 'radiobox') {
                    const childOption = {
                        id: `${option.id}-1`,
                        title: option.extended_title,
                        type: option.type,
                        options: (option.children || []),
                        settings: {}
                    }

                    if(option.type === 'date' && questionSettings === 'max_date_now'){
                        childOption.settings.maxSelectableDate = new Date().toISOString().split('T')[0]
                    }

                    children.push(childOption)
                }

                return {
                    ...option,
                    children,
                    settings: {},
                    type: 'radiobox'
                }
            });
        }
        else{
            options = question.options || [];
        }

        const prevAnswer = answers.find((ans) => ans.id === question.id)

        return {
            ...question,
            options: options,
            is_ai_filled: !!prevAnswer?.is_ai_filled,
            settings: {}
        };
    })
    return result;
}

export const mapAnswers = (questions) => {
    return questions.map((question) => {
        return {
            ...question,
            answers: (question.answers || []).filter((answer) => {
                return (!('value' in answer) && !('title' in answer)) ? false : true;
            }).map((answer) => {
                return {
                    ...answer,
                    children: (answer.children || []).map((child) => {
                        return {
                            ...child,
                            id: child.value || child.id
                        }
                    })
                }
            })
        }
    });
}

export const mapAnswersToSave = (questions, answers) => {
    return answers.map((answer) => {
        const relatedQuestion = questions.find((q) => q.id === answer.question)

        switch(relatedQuestion?.type){
            case 'file_upload':
                return {
                    ...answer,
                    answer: (answer.answer || []).map((file) => {
                        return {
                            name: file.name,
                            title: file.title,
                            file_size: file.attachmentSize
                        }
                    })
                }
            default:
                return answer
        }
    })
} 